import { createContext, PropsWithChildren, useContext, useState } from "react";
import { IntercomProvider as IntercomProviderBase } from "react-use-intercom";

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;
const IntercomUnreadCountContext = createContext(0);

export const useIntercomUnreadCount = () => useContext(IntercomUnreadCountContext);

export const IntercomProvider = (props: PropsWithChildren) => {
	const { children } = props;
	const [unreadCount, setUnreadCount] = useState(0);

	if (!INTERCOM_APP_ID) {
		console.warn("VITE_INTERCOM_APP_ID is not defined. Intercom will not be loaded.");
		return <IntercomUnreadCountContext.Provider value={0}>{children}</IntercomUnreadCountContext.Provider>;
	}

	return (
		<IntercomUnreadCountContext.Provider value={unreadCount}>
			<IntercomProviderBase
				appId={INTERCOM_APP_ID}
				autoBoot={true}
				shouldInitialize={true}
				initializeDelay={200}
				onUnreadCountChange={setUnreadCount}
				autoBootProps={{
					hideDefaultLauncher: true,
				}}
			>
				{children}
			</IntercomProviderBase>
		</IntercomUnreadCountContext.Provider>
	);
};
